module.exports = __webpack_public_path__ + "static/media/3 Train-Lateral_Z1.38b6c3a5.png";